import { Currencies } from "@orbital/games-frontend-library";
import React from "react";
import floorFigure from "../../configs/floorFigure";
import { WinNotificationBody } from "./WinNotificationStyles";
import { WinNotificationEachProps } from "./winNotificationHelpers";
import { useTranslation } from "../../../locale/context";

const WinNotificationEach = ({
  data,
  length,
  which,
  move,
  prec,
}: WinNotificationEachProps) => {
  const { t } = useTranslation();

  return (
    <WinNotificationBody length={length} which={which} move={move}>
      <h1>{t("message.haveWon")} &nbsp;</h1>
      <span>{Currencies[data.currency]}</span>
      <p>{floorFigure(data.cashout.toString(), prec)}</p>
    </WinNotificationBody>
  );
};

export default React.memo(WinNotificationEach);
